import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { getMiljoMakuleringer as getMiljoMakuleringerAction } from "../../../actions/miljoMakuleringerActions";
import { getMostRecentObjectComparedOnParameter } from "../../../utils/date";

export default function MakuleringsarsakContainer() {
  const dispatch = useDispatch();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const mostRecentMakulering = useSelector((state) =>
    state.miljoMakuleringer
      ? getMostRecentObjectComparedOnParameter(
          state.miljoMakuleringer,
          "makuleringDato",
        )
      : null,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (miljogebyr && miljogebyr.id) {
      dispatch(getMiljoMakuleringerAction(miljogebyr.id));
    }
  }, []);

  return (
    <section className="detalj-miljogebyr-section-margin">
      <div style={{ marginTop: 17 }}>
        <h5>Makuleringsårsak</h5>
        <Row>
          <Col md={6}>
            <p style={{ fontSize: 16 }}>
              {(miljogebyr &&
                miljogebyr.isMakulert &&
                mostRecentMakulering &&
                miljogebyr.id === mostRecentMakulering.miljogebyrId &&
                mostRecentMakulering.kommentar) ||
                "-"}
            </p>
          </Col>
        </Row>
      </div>
    </section>
  );
}
